import TagManager from 'react-gtm-module';
import { Cart, CartLineItem } from '@adapters/bigcommerce/types/cart';
import { GA4_EVENT_NAMES } from './constants';
import {
  calculateDiscount,
  determineLowInventoryStatus,
  getGenderFromString,
} from './utils';
interface TrackCartEventProps {
  eventName: string;
  cart: Cart;
  extraAttributes?: { cart_type: string };
}

const { ECOM_INTERACTION, CURRENCY_CAD } = GA4_EVENT_NAMES;

const adaptCartItems = (cartItems: CartLineItem[], couponCode?: string) => {
  return cartItems?.map((cartItem: CartLineItem) => {
    const getOptionValue = (optionName: string) =>
      cartItem.options?.find((option) => option.name === `cart.${optionName}`)
        ?.value;

    const colour = getOptionValue('colour');
    const size = getOptionValue('size');

    const extractedGender = getGenderFromString(cartItem?.name);
    const { discount, discountTier } = calculateDiscount(
      cartItem.extended_list_price ?? 0,
      cartItem.extended_sale_price ?? 0
    );

    return {
      item_id: cartItem.code ?? null,
      item_name: cartItem.name ?? null,
      item_variant: cartItem.sku ?? null,
      price: cartItem.list_price ?? null,
      quantity: cartItem.quantity ?? null,
      item_description_coming_soon: cartItem.noItemDescription ?? null,
      discount: cartItem?.discount_amount || discount || null,
      coupon: couponCode || null,
      item_gender: extractedGender ?? null,
      item_colour: colour ?? null,
      item_size: size ?? null,
      item_sticker: cartItem?.variantBadge?.toLowerCase() ?? null,
      discount_tier: discountTier ?? null,
      item_brand: cartItem?.brand ?? null,
      item_category: cartItem?.category ?? null,
      item_low_inventory_callout: determineLowInventoryStatus(cartItem),
    };
  });
};

const trackCartViewEvent = ({
  eventName = '',
  cart,
  extraAttributes,
}: TrackCartEventProps) => {
  const adaptedCartItems = adaptCartItems(
    [
      ...(cart?.cartData?.line_items?.digital_items || []),
      ...(cart?.cartData?.line_items?.physical_items || []),
    ],
    cart?.cartData?.coupons?.[0]?.code
  );

  TagManager.dataLayer({ dataLayer: { ecommerce: null } }); // Clear ecommerce object

  TagManager.dataLayer({
    dataLayer: {
      event: ECOM_INTERACTION,
      event_name: eventName,
      ecommerce: {
        currency: CURRENCY_CAD,
        value: cart?.cartData?.base_amount || null,
        coupon: cart?.cartData?.coupons?.[0]?.code || null,
        items: adaptedCartItems,
        ...extraAttributes,
      },
    },
  });
};

export default trackCartViewEvent;
